import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_rt8fmuccyw: FaireBrandEntity = {
  token: "b_rt8fmuccyw",
  type: "brand",
  name: "Caspar Curiosities",
  avatarUrl:
    "https://cdn.faire.com/fastly/27904e3a60b589826146ae223208c3530958bceb6c88b8550e441436a7e0d3ee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/46e6bde14db3b2a35380497b83867acc4d2485a590cfece4f30d5d5acc605f4c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/27904e3a60b589826146ae223208c3530958bceb6c88b8550e441436a7e0d3ee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/46e6bde14db3b2a35380497b83867acc4d2485a590cfece4f30d5d5acc605f4c.jpeg",
  location: "Warwick, RI, USA",
  minimumOrderDollars: 346,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Caspar Curiosities was founded in 2015 in the sleepy ghost town of Caspar, California. There, Caspar Curiosities began its life as an outsider art gallery and crystal shop in a very uniquely renovated 1940s gas station (pictured in our shop banner).\nIn 2022, we decided to move our crystal business east to Rhode Island. We are currently online only at this time and expanding into wholesale.\nWe offer high quality crystals ethically sourced direct from around the world working directly with the mines whenever possible. Rare Lemurian and pink Lithium crystals are our specialty.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.437Z",
    importedBy: "entity-db-cli",
  },
};
